'use client';

import Script from 'next/script';
import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect, Suspense } from 'react';
import { trackPageView } from '@/lib/meta-events';

const PIXEL_ID = process.env.NEXT_PUBLIC_META_PIXEL_ID;

function PageViewTracker() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    const url = `https://xgenious.com${pathname}${searchParams.toString() ? `?${searchParams}` : ''}`;
    trackPageView(url);
  }, [pathname, searchParams]);

  return null;
}

// Base code loads lazyOnload to stay off the main thread during hydration (INP/LCP).
// PageView is fired only by PageViewTracker (with an event_id shared with CAPI);
// calls made before fbevents loads are queued in window.__xgPixelQueue and replayed above.
export default function MetaPixel() {
  if (!PIXEL_ID) return null;

  return (
    <>
      <Script id="meta-pixel" strategy="lazyOnload">
        {`!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','${PIXEL_ID}');var q=window.__xgPixelQueue||[];window.__xgPixelQueue=[];q.forEach(function(a){fbq.apply(null,a)});`}
      </Script>
      <noscript>
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img height="1" width="1" style={{ display: 'none' }}
          src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`}
          alt="" />
      </noscript>
      <Suspense>
        <PageViewTracker />
      </Suspense>
    </>
  );
}
